export type RenewalStructure = 'Anniversary' | 'Fixed date' | 'Lifetime'

export type RenewalTerm =
  | 'Monthly'
  | 'Quarterly'
  | 'Twice a year'
  | 'Yearly'
  | 'Every 2 years'
  | 'Every 3 years'

export type MembershipLevelKind = 'individual' | 'organization'

export interface MembershipLevel {
  id: number
  name: string
  description: string | null
  fee: string
  price_label?: string
  free: boolean
  renewal_structure: RenewalStructure
  renewal_term: RenewalTerm | null
  fixed_renewal_date: string | null
  renewal: string
  level_change_renewal_due_on: string | null
  member_count: number
  membership_count?: number
  people_with_member_status_count?: number
  include_in_member_directory?: boolean
  archived: boolean
  available_for_assignment: boolean
  kind?: MembershipLevelKind
  roster_cap?: number | null
  published_to_join_form: boolean
  requires_admin_approval: boolean
  prorate_first_partial_period: boolean
  tax_rate?: TaxRateSummary | null
  level_change_targets?: MembershipLevelSummary[]
  renewal_settings?: MembershipLevelRenewalSettings
}

export interface MembershipLevelRenewalTouch {
  id?: string
  offset: number
}

export interface MembershipLevelRenewalSettings {
  inherited: boolean
  grace_days_override: number | null
  reminder_touches_override: MembershipLevelRenewalTouch[] | null
  effective_grace_days: number
  effective_reminder_touches: MembershipLevelRenewalTouch[]
}

export interface MembershipLevelSummary {
  id: number
  name: string
}

export interface TaxRateSummary {
  id: number
  name: string
  percentage: string
}

export interface MembershipLevelsResponse {
  membership_levels: MembershipLevel[]
}

export interface MembershipLevelResponse {
  membership_level: MembershipLevel
}

export interface MembershipLevelFutureRenewalWarning {
  member_count: number
  message: string
}

export interface MembershipLevelRosterCapWarning {
  new_cap: number
  organizations: Array<{ name: string; roster_size: number }>
}

export interface MembershipLevelForm {
  name: string
  kind: MembershipLevelKind
  rosterCap: string
  description: string
  fee: string
  renewalStructure: RenewalStructure
  renewalTerm: RenewalTerm
  fixedRenewalDate: string
  publishedToJoinForm: boolean
  requiresAdminApproval: boolean
  prorateFirstPartialPeriod: boolean
  taxRateId: string
  levelChangeTargetIds: number[]
}

export type MembershipLevelDialogState =
  | { mode: 'new' }
  | { mode: 'edit'; level: MembershipLevel }
  | null

export interface MembershipLevelFutureRenewalConfirmation {
  level: MembershipLevel
  form: MembershipLevelForm
  warning: MembershipLevelFutureRenewalWarning
}

export interface MembershipLevelRosterCapConfirmation {
  level: MembershipLevel
  form: MembershipLevelForm
  warning: MembershipLevelRosterCapWarning
}

export const renewalStructures: RenewalStructure[] = ['Anniversary', 'Fixed date', 'Lifetime']

export const renewalTerms: RenewalTerm[] = [
  'Monthly',
  'Quarterly',
  'Twice a year',
  'Yearly',
  'Every 2 years',
  'Every 3 years',
]
